import React, { useMemo, useState, useEffect } from "react";
import "./EmploymentRecruitMain.scss";
import { Link } from "react-router-dom";
import { getEmploymentsAction } from "../../../action/employmentAction";
import { useResponsive } from "view/styles/Responsive";
import useTranslationCustom from "../../assets/image/community-section-1/useTranslationCustom";

function EmploymentRecruitMain(props) {
  const limit = 20;
  const { isMobile } = useResponsive();
  const [recruitsData, setRecruitsData] = useState();
  const getRecruits = async (selectedLanguage) => {
    const { result, error } = await getEmploymentsAction(
      selectedLanguage,
      limit
    );
    if (error) {
      return;
    }
    setRecruitsData(result.employments);
  };
  const { i18n } = useTranslationCustom({
    prefix: "",
    nameSpace: "global_navigation",
  });

  let languages = i18n.resolvedLanguage;
  const [selectedLanguage, setSelectedLanguage] = useState();
  useEffect(() => {
    setSelectedLanguage(languages);
  }, [languages]);

  useEffect(() => {
    if (selectedLanguage) {
      getRecruits(selectedLanguage);
    }
  }, [selectedLanguage]);
  return (
    <div className="employment-recruit-section-1 container">
      <div className="employment-recruit-section-1-content">
        {recruitsData?.map((el, index) => {
          return (
            <Link to={`/employment/recruit/${el.employment_id}`}>
              <div
                className="employment-recruit-section-1-content-item"
                key={index}
              >
                <div className="employment-recruit-section-1-content-item-name">
                  {el.position}
                </div>
                <div className="employment-recruit-section-1-content-item-job">
                  {el.group.split(",").join(` ・ `)}
                </div>
                {!isMobile && (
                  <>
                    <div className="employment-recruit-section-1-content-item-form">
                      {el.type}
                    </div>
                    <div className="employment-recruit-section-1-content-item-company">
                      {el.company}
                    </div>
                  </>
                )}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default EmploymentRecruitMain;
